<template>
  <v-container mt-1>
    <h1>My Account</h1>
    <p v-if="userData">Signed in as {{ userData.userName }} ({{ userData.fullName }})</p>

    <v-layout row wrap v-if="mfaEnabled">
      <v-flex xs12 md6>
        <AuthenticatorSetupCard
          :enrolled="enrolled"
          :totp-enabled="totpEnabled"
          @enrolled="onEnrolled"
          @disabled="onDisabled"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import AuthenticatorSetupCard from '@/components/AuthenticatorSetupCard.vue'
import ApiService from '@/services/api.service'

export default {
  name: 'my-account',
  components: { AuthenticatorSetupCard },
  data() {
    return {
      enrolled: false,
      totpEnabled: false,
      mfaEnabled: false
    }
  },
  computed: {
    ...mapGetters('auth', ['userData'])
  },
  async created() {
    await this.refreshEnrollment()
  },
  methods: {
    async refreshEnrollment() {
      try {
        const r = await ApiService.get('/api/Account/UserInfo')
        this.enrolled = !!r.data.HasAuthenticator
        this.totpEnabled = !!r.data.TotpEnabled
        this.mfaEnabled = !!r.data.MfaEnabled
      } catch (e) {
        this.enrolled = false
        this.totpEnabled = false
        this.mfaEnabled = false
      }
    },
    onEnrolled() { this.enrolled = true },
    onDisabled() { this.enrolled = false }
  }
}
</script>
